import { defineMessages } from 'react-intl';

export default defineMessages({
    buildingNumberHeader: {
        id: 'wmic.pe-capability-quoteandbind-cp-react.util.Building Number',
        defaultMessage: 'Building #{buildingNumber}'
    },
});
